/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu 4 Jan 2023 07:55:13
 *
 *******************************************************/
// @flow

import { getJSON } from 'redux-api-middleware';

import apiService from 'src/services/api-service';
import {
  UPDATE_PRODUCT_PERFORMANCE_RANKING_FAILURE,
  UPDATE_PRODUCT_PERFORMANCE_RANKING_REQUEST,
  UPDATE_PRODUCT_PERFORMANCE_RANKING_SUCCESS,
  GET_PRODUCT_PERFORMANCE_RANKING_FAILURE,
  GET_PRODUCT_PERFORMANCE_RANKING_REQUEST,
  GET_PRODUCT_PERFORMANCE_RANKING_SUCCESS,
  STOP_TRIGGER_SYNC_PRODUCT_PERFORMANCE_RANKING,
  TRIGGER_SYNC_PRODUCT_PERFORMANCE_RANKING
} from 'src/stores/flow-type/product-performance-ranking.type';
import { processRes } from 'src/helpers/actions-helper';

export const getSettings = i18n => {
  return apiService.sendRequest(
    'admin-v3.product-performance-ranking.get-product-performance-ranking',
    {},
    [
      GET_PRODUCT_PERFORMANCE_RANKING_REQUEST,
      {
        type: GET_PRODUCT_PERFORMANCE_RANKING_SUCCESS,
        payload: async (action, state, res) => {
          const data = await getJSON(res);
          return { data };
        }
      },
      {
        type: GET_PRODUCT_PERFORMANCE_RANKING_FAILURE,
        payload: async (action, state, res) => {
          const data = await getJSON(res);

          return { data };
        }
      }
    ]
  );
};

export const updateSettings = (data: { enabled: boolean, numberReordered: number }, i18n) => {
  return apiService.sendRequest(
    'admin-v3.product-performance-ranking.update-product-performance-ranking',
    { body: data },
    [
      UPDATE_PRODUCT_PERFORMANCE_RANKING_REQUEST,
      {
        type: UPDATE_PRODUCT_PERFORMANCE_RANKING_SUCCESS,
        payload: async (action, state, res) => {
          const message = i18n.translate(
            'AdminHTML.ProductPerformanceRanking.Actions.updateSettings_Success'
          );
          const data = await processRes(res, 'info', message, i18n);
          return { data };
        }
      },
      {
        type: UPDATE_PRODUCT_PERFORMANCE_RANKING_FAILURE,
        payload: async (action, state, res) => {
          return await processRes(
            res,
            'error',
            i18n.translate('AdminHTML.ProductPerformanceRanking.Actions.updateSettings_Failure'),
            i18n
          );
        }
      }
    ]
  );
};

export const triggerCheckSyncSemantic = () => ({
  type: TRIGGER_SYNC_PRODUCT_PERFORMANCE_RANKING
});

export const stopTriggerCheckSyncSemantic = () => ({
  type: STOP_TRIGGER_SYNC_PRODUCT_PERFORMANCE_RANKING
});
